import classNames, { Argument } from "classnames/dedupe";
import React, { FC, useContext } from "react";
import { FilterPlusIcon, SortIcon } from "../../../../icons";
import {
  AccordionTitle,
  accordionContext,
} from "../../../ActionsSelectors/Accordion";
import CounterBadge, {
  ICounterBadgeProps,
} from "../../../Atoms/CounterBadge/CounterBadge";
import { SvgIcon } from "../../../Icons";
import { TThemeVariant } from "../../../Utility/ThemeProvider";

export interface IFilterAccordionTitleBaseProps {
  /**
   * Visual representation of component
   *
   */
  variant?: TThemeVariant;

  /**
   *
   */
  iconVariant?: "sort" | "expand";
  /**
   * Bold text in accordion clickable title
   */
  title?: string;
  /**
   * Additional small text below accordion title
   */
  subtitle?: string;
  /**
   * Badge data that will be passed to CounterBadge component.
   * If set CounterBadge is rendered on the right part of container,
   * otherwise SVG icons '+' or '-' is rendered
   *
   * @type {ICounterBadgeProps}
   */
  badge?: ICounterBadgeProps;
  /**
   * The custom set of css classes used to style component
   */
}

export interface IFilterAccordionTitleProps
  extends IFilterAccordionTitleBaseProps {
  classes?: {
    /**
     * applied to title element
     */
    root?: Argument;
  };
}

const FilterAccordionTitle: FC<IFilterAccordionTitleProps> = ({
  variant,
  iconVariant = "expand",
  title,
  subtitle,
  badge,
  classes,
}) => {
  const context = useContext(accordionContext);

  const theme = variant || context.theme;

  const rootClasses = classNames("filter-accordion-info__title", classes?.root);

  const buttonClasses = classNames({
    "color-blue": theme === "light",
    "color-white": theme === "dark",
  });

  const expandIcon = (
    <SvgIcon
      icon={FilterPlusIcon}
      classes={{
        root: classNames(buttonClasses, {
          "filter-icon--active": context.expanded,
        }),
      }}
    />
  );

  const icon =
    iconVariant === "sort" ? (
      <SvgIcon
        icon={SortIcon}
        classes={{
          root: buttonClasses,
        }}
      />
    ) : (
      expandIcon
    );

  return (
    <AccordionTitle
      classes={{
        root: "filter-accordion-head",
      }}
      data-testid="accordion-title"
    >
      <div className="filter-accordion-info">
        <div className={rootClasses}>{title}</div>
        {!context.expanded && subtitle ? (
          <div className="filter-accordion-info__selected">{subtitle}</div>
        ) : null}
      </div>
      <div className="filter-accordion-status">
        {/* eslint-disable-next-line no-nested-ternary */}
        {badge?.count > 0 && (
          <CounterBadge count={badge.count} variant={badge.variant} />
        )}
        {!badge?.count && icon}
      </div>
    </AccordionTitle>
  );
};

export default FilterAccordionTitle;
